export default "__VITE_ASSET__60eab2c5__"